export const SNACKBAR_OPEN = "SNACKBAR_OPEN"
export const SNACKBAR_CLOSE = "SNACKBAR_CLOSE"
